var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAddFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9,9 L6.99754465,9 C6.4463114,9 6,9.44724809 6,9.99895656 L6,11.0010434 C6,11.5573397 6.44661595,12 6.99754465,12 L9,12 L9,14.0024554 C9,14.5536886 9.44724809,15 9.99895656,15 L11.0010434,15 C11.5573397,15 12,14.553384 12,14.0024554 L12,12 L14.0024554,12 C14.5536886,12 15,11.5527519 15,11.0010434 L15,9.99895656 C15,9.44266033 14.553384,9 14.0024554,9 L12,9 L12,6.99754465 C12,6.4463114 11.5527519,6 11.0010434,6 L9.99895656,6 C9.44266033,6 9,6.44661595 9,6.99754465 L9,9 Z M10.5,0 C16.296,0 21,4.704 21,10.5 C21,16.296 16.296,21 10.5,21 C4.704,21 0,16.296 0,10.5 C0,4.704 4.704,0 10.5,0 Z"
})))));
export default SvgAddFill;